import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import { selectHeaderHeight, selectIsBackButtonDisplayed } from '../../store/ui/ui.selectors'
import { selectIsUserAccountEnabled } from '../../store/userAccount/userAccount.selectors'
import { isPE } from '../Device'
import UserButton from '../UserAccount/UserButton'
import MenuCategoriesPE from '../menu/MenuCategoriesPE'
import useComputedHeaderHeight from '../ui/useHeaderHeight'
import useUIDisplay from '../ui/useUIDisplay'
import DesktopPreHeader from './DesktopPreHeader'
import s from './Header.less'
import SubHeader from './SubHeader'

export const Header = ({
  subHeader,
  subHeaderSelectorConditionFn = () => true,
  headerButton,
  children,
  menuCategoriesPE
}) => {
  const { isUIDisplayed: suggestDisplayed } = useUIDisplay(UI_ELEMENTS.SUGGEST)
  const { isUIDisplayed: searchDialogDisplayed } = useUIDisplay(UI_ELEMENTS.SEARCH_DIALOG)
  const backButtonDisplayed = useSelector(selectIsBackButtonDisplayed)
  const headerHeight = useSelector(selectHeaderHeight)

  const shouldDisplaySubHeaderComponent = useSelector(subHeaderSelectorConditionFn)
  const subHeaderComponent = shouldDisplaySubHeaderComponent && subHeader

  const userAccountEnabled = useSelector(selectIsUserAccountEnabled)
  const shouldDisplayUserAccount = __BROWSER__ && isPE() && userAccountEnabled && !backButtonDisplayed

  const shouldDisplayMenuCategoriesPE = menuCategoriesPE && !suggestDisplayed && !searchDialogDisplayed

  const computedHeaderHeight = useComputedHeaderHeight(menuCategoriesPE, subHeaderComponent)

  return (
    <header className={s.root} style={{ height: computedHeaderHeight }}>
      <div
        className={classNames(
          s.container,
          backButtonDisplayed && PAGE_CLASSES.withBackButton,
          !suggestDisplayed && headerButton && PAGE_CLASSES.withHeaderButton,
          shouldDisplayUserAccount && PAGE_CLASSES.withUserAccountButton
        )}
        style={{
          height: headerHeight
        }}
      >
        {shouldDisplayUserAccount && <UserButton />}
        {children}
        {!suggestDisplayed && headerButton}
      </div>
      <SubHeader key="SubHeader">{subHeaderComponent}</SubHeader>
      <DesktopPreHeader key={'desktop-pre-header'} />
      {shouldDisplayMenuCategoriesPE && (
        <div className={s.menuCategoriesPE}>
          <MenuCategoriesPE />
        </div>
      )}
    </header>
  )
}

export default Header
